// extracted by mini-css-extract-plugin
export var container = "_du-0";
export var containerTopRight = "_du-1";